import { FC, ReactElement } from 'react';

export type IconProps = {
  width?: string | number;
  height?: string | number;
  color?: string;
};

const LessThanEqual: FC<IconProps> = ({
  width = 16,
  height = 16,
  color = '#333333',
}): ReactElement => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon/Stockbit/Menu Portfolio/Chevron Right">
        <g id="Group 6356642">
          <path
            id="Vector"
            d="M11.5 10L4.5 6L11.5 2"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M4 14H12"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default LessThanEqual;
